import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { useHistory, useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';
import * as actions from '_actions';
import { Arrow } from '../../styles/common-styles';

const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const IframeContainer = styled.div`
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  min-height: 635px;
  margin-top: 10px;

  ${(parentWidth < 706) && css`
    width: 100% !important;
  `};
`;

const Iframe = styled.iframe`
  min-height: 635px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  border: none;

  ${(parentWidth > 627) && css`
    min-width: 628px !important;
  `};

  ${(parentWidth < 629) && css`
    width: 100% !important;
  `};
`;
const Title = styled.h2`
  display:flex;
  align-items: center;
  font-size: 18px !important;
  color: rgba(64,64,64,1);
  font-weight: bold !important;
  border-bottom: 2px solid #E7ECEF;
  padding-bottom: 10px !important;
  padding-left: 10px !important;
  margin-top: 10px !important;
`;

const Campaign = ({
  setShowNationalSurveyPropmt, src, setShowCampignIframe, campaigns, setRef = null
}) => {
  const history = useHistory();
  const { state } = useLocation();

  const ref = useRef(null);
  const [iframeHeight, setIframeHeight] = useState(635 + 50);
  const [iframeWidth, setIframeWidth] = useState(614);

  const goBackHandler = () => {
    setShowCampignIframe(false);
    if (setRef !== null) {
      setRef('campaignRef');
    }
  };

  useEffect(() => {
    setIframeHeight(`${ref.current.contentWindow.document.body.scrollHeight + 50}px`);
    setIframeWidth(`${ref.current.contentWindow.document.body.scrollWidth - 30}px`);
  }, [ref]);

  useEffect(() => {
    const onMessage = (event) => {
      if (event.data === 'Exit') {
        if (src) {
          // education campaign
          setShowCampignIframe(false);
        } else {
          // national survey
          setShowNationalSurveyPropmt(false);
          history.goBack();
        }
      }
    };

    window.addEventListener('message', onMessage);

    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, []);

  return (
    <IframeContainer>
      {src && (
        <Title>
          <Arrow background="#fff" onClick={goBackHandler} aria-label="Go back">
            &#8678;
          </Arrow>
          {campaigns.campaign_nm}
        </Title>
      )}
      <Iframe
        src={src || state.url}
        ref={ref}
        scrolling="no"
        title="Campaign"
        width={iframeWidth}
        height={iframeHeight}
      />
    </IframeContainer>
  );
};

const mapStateToProps = (store) => ({
  campaigns: store.education.campaigns,
  selectedLang: store.config.selectedLang,
});

const mapDispatchToProps = (dispatch) => ({
  setShowNationalSurveyPropmt:
    (showNationalSurveyPropmt) => dispatch(
      actions.alert.setShowNationalSurveyPropmt(showNationalSurveyPropmt)
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(Campaign);
